<template>
  <va-modal
    id="appointmentsModal"
    ref="appointmentsModal"
    :value="isOpen"
    :showOkay="false"
    :cancelText="$t('modals.buttons.back')"
    :fixedLayout="true"
    @cancel="closeModal"
  >
    <div slot="header" class="modal-title">
			{{modalTitle}}
		</div>

    <div v-if="isLoading" class="d-flex align-items-center flex-column py-5">
        <span class="mb-3">{{$t('agenda.screenings.appointments.loading_appointments')}}</span>
        <hollow-dots-spinner
          :animation-duration="1000"
          :size="60"
          color="#29c4a9"
        />
    </div>

    <div v-else-if="!isLoading && Array.isArray(items) && items.length > 0" class="py-3">
      <AppointmentsList
        :screening="screening"
        :showTitle="false"
        :appointments="items"
        :id="null"
        @campaign-added="onCampaignAdded">
        <div slot="header">
          <div class="d-flex justify-content-end title-date">
            {{ appointmentsTitle }}
          </div>
        </div>
      </AppointmentsList>
    </div>

    <div v-else class="py-5 text-center">
      <span>
        {{$t('agenda.screenings.appointments.could_not_load_appointments')}}
      </span>
    </div>

  </va-modal>
</template>
<script>
import AppointmentsList from '@/components/agenda/appointments/AppointmentsList'
import { HollowDotsSpinner } from 'epic-spinners'
import { AvailabilityService } from '@/api/BookingService'
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'

export default {
  props: {
    appointments: {
      type: Array,
      required: false,
      default: null
    },
    screening: {
      type: Object,
      required: true
    }
  },
  components: {
    AppointmentsList,
    HollowDotsSpinner
  },
  mixins: [
    CurrentLocaleMixin
  ],
  data () {
    return {
      isOpen: false,
      isLoading: true,
      items: this.appointments
    }
  },
  created () {
    if (!this.items) {
      AvailabilityService.getAppointments(this.screening.id)
      .then(appointments => {
        this.items = appointments.map(appointment => {
          return {
            ...appointment,
            start: this.$options.filters.localTime(appointment.start),
            end: this.$options.filters.localTime(appointment.end)
          }
        })
      }).catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      })
    }
  },
  mounted () {
    this.isOpen = true
  },
  methods: {
    onCampaignAdded: function ({appointments}) {
      this.items = this.items.concat(appointments)
      this.items.sort((a, b) => {
        return (new Date(a.start)) - (new Date(b.start))
      })
    },
    closeModal: function () {
			this.isOpen = false
			this.$emit('modalClosed')
    }
  },
  computed: {
    modalTitle: function () {
      let facilityName = this.screening.facility ? this.screening.facility.name : this.$t('agenda.screenings.no_facility')
      return `${facilityName} - ${this.$t('agenda.appointments.title')}`
    },
    appointmentsTitle: function () {
      return this.$options.filters.localTime(this.screening.start, 'dddd, LL', '', this.locale)
    }
  }
}
</script>

<style lang="scss">
  #appointmentsModal {
    .appointment-item-details-wrapper {
        max-height: 100%;
        overflow-y: auto;
    }
  }
</style>

<style scoped lang="scss">

.title-date {
  font-size: 16px;
  color:grey;
}
</style>
